import React, { useState, useEffect, useRef } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import "./pincity.css";
import logoimage from './assets/logow.png';
import backposter from './assets/posterback.jpg';

mapboxgl.accessToken =
  "pk.eyJ1IjoiYWpqZXJ1c2FsZW0iLCJhIjoiY2l4b2t3N2lyMDAxMzJxcHMwZ3IzOWN1OSJ9.cxZW0ZgGPFDZpc_-JtRBxg";

const cities =[{"country":"Algeria","img":"GettyImages-567930685.jpg","lat":35.484792,"lon":6.467197,"question":"This North African country is the largest on the continent and home to some of the best-preserved ancient Roman ruins"},{"country":"Angola","img":"GettyImages-170486643.jpg","lat":-15.072573,"lon":13.247008,"question":"Leba Pass links this oil-rich former Portuguese colony's coastal plains to the inland highlands"},{"country":"Benin","img":"GettyImages-2273920146.jpg","lat":6.468534,"lon":2.414803,"question":"Ganvie, the “Venice of Africa”, sits on Lake Nokoue in this small West African nation once known as Dahomey"},{"country":"Botswana","img":"GettyImages-1487610137.jpg","lat":-19.475536,"lon":22.94756,"question":"The Okavango Delta flows through this landlocked country, one of the world's largest diamond producers"},{"country":"Burkina Faso","img":"GettyImages-2240544542.jpg","lat":11.17748,"lon":-4.296118,"question":"The Grand Mosque of Bobo-Dioulasso stands in this West African nation whose name means “land of the upright people”"},{"country":"Burundi","img":"GettyImages-113574045.jpg","lat":-3.327145,"lon":29.322695,"question":"Melchior Ndadaye airport features distinctive dome-shaped roofs in this small country, where Kirundi is the national language"},{"country":"Cape Verde","img":"GettyImages-171852974.jpg","lat":16.888789,"lon":-24.993972,"question":"Cityscape of Mindelo in an archipelago of 10 volcanic islands in the central Atlantic Ocean, whose name means “Green Cape”"},{"country":"Cameroon","img":"GettyImages-1128792339.jpg","lat":5.259974,"lon":8.988188,"question":"The Mana River flows through the rainforest in a country where French and English are both official languages"},{"country":"Central African Republic","img":"GettyImages-1230293675.jpg","lat":4.369652,"lon":18.57802,"question":"This Notre-Dame Cathedral, built in the 1930s, graces Bangui, the capital of a former French colony in the heart of Africa"},{"country":"Chad","img":"GettyImages-1224458334.jpg","lat":17.038405,"lon":21.861597,"question":"The Ennedi Massif is a UNESCO World Heritage Site in this landlocked Saharan nation whose capital is N'Djamena"},{"country":"Comoros","img":"GettyImages-114001923.jpg","lat":-11.672581,"lon":43.35609,"question":"Galawa Beach lies on this Indian Ocean island nation, Africa's only Arab League member south of the equator"},{"country":"DR Congo","img":"GettyImages-1319596147.jpg","lat":-1.52311,"lon":29.249199,"question":"Mount Nyiragongo, home to the world's largest lava lake, sits on the eastern border of the second-largest country in Africa"},{"country":"Republic of the Congo","img":"GettyImages-1449544455.jpg","lat":-4.288007,"lon":15.266973,"question":"The “15 August 1960 Bridge”, named after this country's independence from France, spans the great river dividing Brazzaville from Kinshasa"},{"country":"Djibouti","img":"GettyImages-527494880.jpg","lat":11.592016,"lon":43.146021,"question":"The Hamoudi Mosque is one of the oldest in this small nation, overlooking the Red Sea and the Bab al-Mandeb Strait"},{"country":"Egypt","img":"GettyImages-1058291898.jpg","lat":29.977672,"lon":31.13411,"question":"The Great Pyramids of Giza are more than 4,500 years old and located about 25km (16 miles) southwest of the capital"},{"country":"Equatorial Guinea","img":"GettyImages-1268582024.jpg","lat":3.756793,"lon":8.782703,"question":"The Spanish-built Cathedral of St Isabel is more than 100 years old, standing on an island in Africa’s only Spanish-speaking nation"},{"country":"Eritrea","img":"GettyImages-891946014.jpg","lat":15.617637,"lon":38.95522,"question":"Filfil National Park, notable for its alley of jacaranda trees, lies along the Red Sea in the Horn of Africa"},{"country":"Eswatini","img":"GettyImages-1169544336.jpg","lat":-26.318243,"lon":31.136672,"question":"Downtown Mbabane sits at an elevation of 1,243 metres (4,078ft), in one of Africa's smallest countries, ruled by King Mswati III"},{"country":"Ethiopia","img":"GettyImages-1150323016.jpg","lat":12.031341,"lon":39.041161,"question":"Bet Giyorgis (Church of St George), carved from solid rock in the 12th century, lies about 600km (370 miles) north of Addis Ababa"},{"country":"Gabon","img":"AFP-20220530.jpg","lat":-1.996899,"lon":9.644138,"question":"Elephants roam Loango National Park, where wildlife meets the Atlantic, about 250km (155 miles) south of Libreville"},{"country":"Gambia","img":"GettyImages-1190513599.jpg","lat":13.445018,"lon":-16.718974,"question":"A coastal beach resort along the Atlantic Ocean, in a West African nation shaped by the river that shares its name"},{"country":"Ghana","img":"GettyImages-2223218065.jpg","lat":5.644055,"lon":-0.120532,"question":"A view of Accra's Tema Motorway; this country was the first sub‑Saharan African nation to gain independence in 1957"},{"country":"Guinea","img":"GettyImages-1315174874.jpg","lat":9.506953,"lon":-13.716123,"question":"Palais des Nations, known today as Mohammed V Palace, stands in this predominantly Muslim West African nation whose currency is the Guinean franc"},{"country":"Guinea-Bissau","img":"GettyImages-1193501340.jpg","lat":11.861113,"lon":-15.584157,"question":"Praca dos Herois Nacionais is dedicated to this country's national heroes in this Portuguese‑speaking nation, whose capital is Bissau"},{"country":"Ivory Coast","img":"GettyImages-140214408.jpg","lat":5.380917,"lon":-4.013653,"question":"One of West Africa’s important business districts, in a country that is the world's largest cocoa producer"},{"country":"Kenya","img":"GettyImages-1915816036.jpg","lat":-1.285741,"lon":36.808936,"question":"Nairobi, one of the continent's financial and innovation hubs, is the capital of this East African country"},{"country":"Lesotho","img":"GettyImages-845896366.jpg","lat":-29.871156,"lon":28.053551,"question":"Sesotho and English are the official languages in this small nation, whose Maletsunyane Falls has a drop of nearly 200 metres (656ft)"},{"country":"Liberia","img":"GettyImages-560066045.jpg","lat":6.898683,"lon":-10.827796,"question":"Blue Lake in Bomi Hills is a tranquil spot near Monrovia, whose flag closely resembles that of the United States"},{"country":"Libya","img":"GettyImages-599332136.jpg","lat":32.635588,"lon":14.292419,"question":"Leptis Magna’s theatre is one of the Mediterranean’s finest Roman ruins in the country with Africa’s largest proven oil reserves"},{"country":"Madagascar","img":"GettyImages-sb10066637r-001.jpg","lat":-20.523492,"lon":47.256816,"question":"Ricefields in the village of Zafimaniry de Sakaivo on Africa’s largest island, in the Indian Ocean"},{"country":"Malawi","img":"GettyImages-1188921100.jpg","lat":-15.912708,"lon":35.657391,"question":"Tea plantations at the base of Mount Mulanje in this landlocked country in southeastern Africa, with a rising‑sun flag"},{"country":"Mali","img":"GettyImages-148676580.jpg","lat":12.631564,"lon":-7.998943,"question":"This West African country uses the CFA franc, and its main bank tower rises above the capital, Bamako"},{"country":"Mauritania","img":"GettyImages-610236042.jpg","lat":20.404593,"lon":-13.111197,"question":"The Adrar are mountains in this West African country, 90 percent of which lies in the Sahara Desert, and Arabic is an official language"},{"country":"Mauritius","img":"GettyImages-1302788669.jpg","lat":-20.178987,"lon":57.461418,"question":"Port Louis is the capital of the only Indian Ocean island nation where Hinduism is the most practised religion"},{"country":"Morocco","img":"GettyImages-872356458.jpg","lat":35.166073,"lon":-5.271754,"question":"The town of Chefchaouen in North Africa, known for its blue‑washed alleys, lies about 250km (155 miles) north of the capital, Rabat"},{"country":"Mozambique","img":"GettyImages-148935933.jpg","lat":-12.974242,"lon":40.520897,"question":"Rock formations line the road from Nampula to Pemba in the Portuguese‑speaking nation whose capital is Maputo"},{"country":"Namibia","img":"AFP-20221118.jpg","lat":-24.709092,"lon":15.340344,"question":"Tourists walk at the Sossusvlei salt pan, about 350km (220 miles) southwest of Windhoek in what was once a German colony"},{"country":"Niger","img":"GettyImages-481591451.jpg","lat":16.974075,"lon":7.988361,"question":"The Agadez Mosque, built in 1515, has the world’s tallest mud-brick minaret at 27 metres (89ft), in the landlocked Saharan nation named after a river"},{"country":"Nigeria","img":"GettyImages-481660979.jpg","lat":9.125115,"lon":7.229745,"question":"The continent’s most populous nation in West Africa, with more than 240 million people, features Zuma Rock on its banknotes"},{"country":"Rwanda","img":"GettyImages-1199223252.jpg","lat":-1.432352,"lon":29.593964,"question":"The Land of a Thousand Hills, where Intore dancers perform near Volcanoes National Park and Kinyarwanda is the national language"},{"country":"Sao Tome and Principe","img":"AFP-20180105.jpg","lat":0.117679,"lon":6.565871,"question":"The jagged Pico Cao Grande, a volcanic landmark on a remote Atlantic island just off the equator, is named after Saint Thomas the Apostle"},{"country":"Senegal","img":"GettyImages-2230725502.jpg","lat":14.666271,"lon":-17.39772,"question":"Goree Island, off the coast of Dakar, is a UNESCO-listed memorial to the Atlantic slave trade in Africa's westernmost mainland country"},{"country":"Seychelles","img":"GettyImages-903874226.jpg","lat":-4.358972,"lon":55.832697,"question":"Famous for its granite coastline, this beach lies in Africa’s smallest country, in the Indian Ocean"},{"country":"Sierra Leone","img":"AFP-20250617.jpg","lat":8.416897,"lon":-13.207567,"question":"Tacugama Chimpanzee Sanctuary sits in the hills just outside Freetown, whose name means “Lion Mountains” in Portuguese"},{"country":"Somalia","img":"GettyImages-2232959854.jpg","lat":2.040168,"lon":45.362906,"question":"Liido Beach is known for its bright turquoise Indian Ocean waters near the Gulf of Aden, along the longest coastline on mainland Africa"},{"country":"South Africa","img":"GettyImages-2270611729.jpg","lat":-33.963645,"lon":18.410106,"question":"This flat-topped mountain, resembling a table, is one of the country’s most recognisable natural landmarks, in a nation with 12 official languages"},{"country":"South Sudan","img":"AFP-20110622.jpg","lat":8.1386,"lon":30.647371,"question":"The Sudd wetlands, north of the capital, Juba, are a vast marshland in the world’s youngest nation"},{"country":"Sudan","img":"GettyImages-564017851.jpg","lat":18.563343,"lon":31.916309,"question":"Meroe, the ancient Kushite capital, has more than 200 pyramids, in a country where the Blue and White Nile converge"},{"country":"Tanzania","img":"AP22060197455085.jpg","lat":-3.069053,"lon":37.355456,"question":"Mount Kilimanjaro, which lies just along the border, is Africa’s highest mountain, with a 5,895-metre (19,341-foot) peak"},{"country":"Togo","img":"GettyImages-1314860441.jpg","lat":10.065728,"lon":1.123042,"question":"The Batammariba people built these earth homes, recognised as a World Heritage Site, in this narrow West African nation"},{"country":"Tunisia","img":"GettyImages-1277724733.jpg","lat":35.296306,"lon":10.706962,"question":"The Roman amphitheatre of El Jem was built in the third century in the northernmost country on mainland Africa"},{"country":"Uganda","img":"GettyImages-2071237293.jpg","lat":-1.052753,"lon":29.620076,"question":"Bwindi Impenetrable Forest is a dense rainforest known for its mountain gorillas, in a nation sitting on the shores of Lake Victoria"},{"country":"Zambia","img":"GettyImages-1245847648.jpg","lat":-17.925637,"lon":25.858717,"question":"Victoria Falls, which lies between two Southern African countries, is one of the largest waterfalls in the world"},{"country":"Zimbabwe","img":"GettyImages-1095399818.jpg","lat":-17.017893,"lon":27.87012,"question":"Lake Kariba, one of the world’s largest human-made lakes, sits on the border of two landlocked Southern African nations"}]
// ── Instructions Modal ────────────────────────────────────────────────────────
function InstructionsModal({ onStart }) {
  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
      zIndex: 10000,
      // background: "linear-gradient(160deg, #0a1628 0%, #1a3a2a 50%, #0a1628 100%)",
      background:"rgba(51,51,51,1)",
      backgroundImage: `url(${backposter})`,
      backgroundPosition: "50% 50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      backdropFilter: "blur(12px)",
      padding: "24px",
    }}>

      {/* Decorative background pattern */}
      <div style={{
        position: "absolute", inset: 0, opacity: 0.04,
        backgroundImage: `radial-gradient(circle, #333 1px, transparent 1px)`,
        backgroundSize: "32px 32px",
        pointerEvents: "none",
      }} />

      {/* Card */}
      <div style={{
        position: "relative",
        // background: "rgba(0,0,0,0.2)",

        // border: "1px solid rgba(255,255,255,0.12)",
        borderRadius: "16px",
        padding: "48px 40px",
        maxWidth: "600px",
        width: "100%",
        textAlign: "center",
        // boxShadow: "0 32px 80px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.08)",
      }}>
        {/* Globe icon */}
        <div style={{ fontSize: "52px", marginBottom: "12px", lineHeight: 1 }}>🌍</div>

        {/* Title */}
        <h1 style={{
          color: "#fff",
          fontSize: "clamp(24px, 5vw, 32px)",
          fontWeight: "700",
          margin: "0 0 6px",
          letterSpacing: "-0.5px",
          lineHeight: 1.2,
        }}>
          How well do you know Africa?
        </h1>

        <p style={{
          color: "#eee",
          fontSize: "18px",
          letterSpacing: "2px",
          textTransform: "uppercase",
          margin: "10px 10px 28px",
          fontFamily: "sans-serif",
        }}>
          MAP QUIZ
        </p>

        {/* Divider */}
        <div style={{
          width: "48px", height: "2px",
          background: "linear-gradient(90deg, transparent, #bf3640, transparent)",
          margin: "0 auto 28px",
        }} />

        {/* How to play steps */}
        <div style={{ textAlign: "center", lineHeight: "1.4", fontWeight:"500", marginBottom: "40px" }}>
          {[
            { icon: "📷", text: "You'll be shown a photo of a location in Africa." },
            { icon: "🗺️", text: "Study the image, then drop a pin where you think it is." },
            { icon: "📍", text: "The closer your guess, the more points you earn." },
            { icon: "🌍", text: "Each game has 10 random locations from 54 African countries." },
            { icon: "🏆", text: "Can you score a perfect 100?" },
          ].map(({ icon, text }, i) => (
            <div key={i} style={{
              display: "flex", alignItems: "center", justifyContent: "center", gap: "14px",
              marginBottom: i < 4 ? "10px" : 0,
            }}>
              <span style={{ fontSize: "20px", lineHeight: "1.5", flexShrink: 0 }}>{icon}</span>
              <p style={{
                color: "#fff",
                fontSize: "16px",
                textAlign:"center",
                margin: 0,
              }}>{text}</p>
            </div>
          ))}
        </div>

        {/* CTA button */}
        <button
          onClick={onStart}
          className="buttonguess"
        >
          LET'S PLAY →
        </button>

      </div>
    </div>
  );
}

// ── Fullscreen Image Modal ────────────────────────────────────────────────────
const IMG_DURATION = 5000;

function ImageModal({ city, onClose }) {
  const [timeLeft, setTimeLeft] = useState(IMG_DURATION);
  const [timerDone, setTimerDone] = useState(false);
  const intervalRef = useRef(null);

  const startTimer = () => {
    setTimerDone(false);
    setTimeLeft(IMG_DURATION);
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 100) {
          clearInterval(intervalRef.current);
          setTimerDone(true);
          return 0;
        }
        return prev - 100;
      });
    }, 100);
  };

  useEffect(() => {
    startTimer();
    return () => clearInterval(intervalRef.current);
  }, [city]);

  const pct = (timeLeft / IMG_DURATION) * 100;

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
      zIndex: 9999,
      background: "#333",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    }}>
      <p className="text-center cityguess" style={{ padding: "0 24px 16px", maxWidth: 700 }}>
        {city.question}
      </p>
      <div style={{ position: "relative", width: "100%", maxWidth: 1000 }}>
        <img
          src={city.img}
          alt="Location clue"
          style={{ width: "100%", maxHeight: "70vh", objectFit: "cover", display: "block" }}
        />
      </div>
      <div style={{ display: "flex", gap: 12, marginTop: 20, alignItems: "center" }}>
        <button className="buttonguess" onClick={onClose}>
          I'm ready to guess - show map
        </button>
      </div>
    </div>
  );
}

// ── Helpers ───────────────────────────────────────────────────────────────────
function shuffleArray(array) {
  const result = [...array];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

function haversine(lat1, lon1, lat2, lon2) {
  const toRad = (deg) => (deg * Math.PI) / 180;
  const R = 6371;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
  return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
}

// ── Main component ────────────────────────────────────────────────────────────
export default function PinTheCity() {
  const mapContainer = useRef(null);
  const mapRef = useRef(null);
  const markerRefs = useRef([]);

// Add this ref to track unused cities (put with other refs at top of PinTheCity)
const unusedCitiesRef = useRef(shuffleArray([...cities]));

// Replace the shuffledCities useState with this:
const [shuffledCities, setShuffledCities] = useState(() => {
  const picked = unusedCitiesRef.current.splice(0, 10);
  return picked;
});



  const [cityIndex, setCityIndex] = useState(0);
  const [guess, setGuess] = useState(null);
  const [score, setScore] = useState(0);
  const [totalScore, setTotalScore] = useState(0);
  const [revealed, setRevealed] = useState(false);
  const [gameOver, setGameOver] = useState(false);
  const [showFinalScoreButton, setShowFinalScoreButton] = useState(false);

  // Show instructions first, then image modal per round
  const [showInstructions, setShowInstructions] = useState(true);
  const [showImageModal, setShowImageModal] = useState(false);

  const city = shuffledCities[cityIndex];
  const correct = { lat: city.lat, lon: city.lon };

  // Preload current + next 2 images
useEffect(() => {
  const toPreload = shuffledCities.slice(cityIndex, cityIndex + 3);
  toPreload.forEach(({ img }) => {
    const image = new Image();
    image.src = img;
  });
}, [cityIndex, shuffledCities]);

  function getZoomLevel() {
    const width = window.innerWidth;
    if (width <= 480) return 1.8;
    if (width > 480 && width <= 768) return 2.3;
    if (width > 768 && width <= 1120) return 2.5;
    return 2.8;
  }

  const handleStart = () => {
    setShowInstructions(false);
    setShowImageModal(true);
  };

  useEffect(() => {
    if (!mapRef.current) {
      mapRef.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: "mapbox://styles/ajjerusalem/cmp9cfmzu002i01sdclaybenf",
        center: [17, -5],
        zoom: getZoomLevel(),
        minZoom: 1.5,
        maxZoom: 6,
        interactive: true,
      });

      mapRef.current.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-left');

      mapRef.current.on("click", (e) => {
        if (!revealed) {
          const { lng, lat } = e.lngLat;
          setGuess({ lat, lon: lng });
        }
      });

      mapRef.current.getCanvas().style.cursor = 'default';
      mapRef.current.on('mouseleave', () => {
        mapRef.current.getCanvas().style.cursor = 'default';
      });
    }
  }, [revealed]);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;

    markerRefs.current.forEach((marker) => marker.remove());
    markerRefs.current = [];

    if (guess) {
      const guessMarker = new mapboxgl.Marker({ color: "red" })
        .setLngLat([guess.lon, guess.lat])
        .addTo(map);
      markerRefs.current.push(guessMarker);
    }

    if (revealed) {
      const correctMarker = new mapboxgl.Marker({ color: "green" })
        .setLngLat([correct.lon, correct.lat])
        .addTo(map);
      markerRefs.current.push(correctMarker);
    }
  }, [guess, revealed]);

  const revealAnswer = () => {
    if (!guess) return;
    const distance = haversine(guess.lat, guess.lon, correct.lat, correct.lon);
    let roundScore = 0;
    if (distance < 300) roundScore = 10;
    else if (distance < 500) roundScore = 9;
    else if (distance < 800) roundScore = 8;
    else if (distance < 1200) roundScore = 7;
    else if (distance < 1500) roundScore = 6;
    else if (distance < 1900) roundScore = 5;
    else if (distance < 2400) roundScore = 4;
    else if (distance < 2900) roundScore = 3;
    else if (distance < 3700) roundScore = 2;
    else if (distance < 4300) roundScore = 1;
    else roundScore = 0;

    setTotalScore((prev) => prev + roundScore);
    setScore(roundScore);
    setRevealed(true);

    if (cityIndex === shuffledCities.length - 1) {
      setShowFinalScoreButton(true);
    }
  };

  const nextRound = () => {
    const nextIndex = cityIndex + 1;
    if (nextIndex >= shuffledCities.length) {
      setGameOver(true);
    } else {
      setCityIndex(nextIndex);
      setGuess(null);
      setRevealed(false);
      setShowImageModal(true);
    }
  };

  const restartGame = () => {
    // If fewer than 10 left, refill and reshuffle the pool
    if (unusedCitiesRef.current.length < 10) {
      unusedCitiesRef.current = shuffleArray([...cities]);
    }
    const picked = unusedCitiesRef.current.splice(0, 10);
  
    setShuffledCities(picked);
    setGameOver(false);
    setCityIndex(0);
    setTotalScore(0);
    setScore(0);
    setGuess(null);
    setRevealed(false);
    setShowInstructions(true);
    setShowImageModal(false);
  };

  const tweetText = `How well do you know Africa? I scored ${totalScore}/100. @AJEnglish @AJLabs - play here: https://aljazeera.com/africaquiz`;
  const whatsText = `How well do you know Africa? I scored ${totalScore}/100. @AJEnglish @AJLabs — play here: https://aljazeera.com/africaquiz`;
  const tweeturl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}`;
  const whatsurl = `whatsapp://send?text=${encodeURIComponent(whatsText)}`;

  return (
    <div className="relative w-full h-screen flex flex-col items-center p-4">

      {/* ── Instructions modal — shown first, before anything else ── */}
      {showInstructions && (
        <InstructionsModal onStart={handleStart} />
      )}

      {/* ── Fullscreen image modal — shown at start of each round ── */}
      {showImageModal && !gameOver && !showInstructions && (
        <ImageModal
          key={cityIndex}
          city={city}
          onClose={() => setShowImageModal(false)}
        />
      )}

      {/* ── HUD ─────────────────────────────────────────────────────────────── */}
      <div>
      <div className="centerbarx flex flex-col items-center">
        <div className="text-sm font-semibold bg-white px-2 py-1 rounded shadow">
          <a href="https://aljazeera.com" target="_blank" rel="noopener noreferrer">
            <img src={logoimage} alt="Al Jazeera" style={{ width: "120px", height: "auto" }} />
          </a>
        </div>
      </div>

      <div className="rightbarx flex flex-col items-center">
        <div className="text-sm font-semibold bg-white px-2 py-1 rounded shadow">
          Score: {totalScore}/100
        </div>
      </div>

      <div className="leftbarx flex flex-col items-center">
        <div className="text-sm font-semibold bg-white px-2 py-1 rounded shadow">
          Question: {cityIndex + 1}/{shuffledCities.length}
        </div>
      </div>
      </div>

      <p className="text-center whereis font-bold mb-2"></p>
      <p className="text-center cityguess">{city.question}</p>
      <p className="text-guess pad-bottom text-center font-bold mb-2">
        {!showImageModal && (
          <button
            className="buttonguess2 mt-2 px-4 py-2"
            onClick={() => setShowImageModal(true)}
          >
            📷 Show image again
          </button>
        )}
      </p>

      <div
        ref={mapContainer}
        style={{ height: "80vh", width: "100%" }}
        className="mb-4"
      />

      {!revealed && (
        <div className="submitbutton text-center mb-4">
          <div>
            <p className="text-guess pad-bottom text-center font-bold mb-2">
              Drop a pin 📍 on the map 🌍 to guess
            </p>
            <button
              className="buttonguess mt-2 px-4 py-2 bg-blue-600 text-white rounded disabled:opacity-50"
              onClick={revealAnswer}
              disabled={!guess}
            >
              Submit guess
            </button>
          </div>
        </div>
      )}

      {revealed && (
        <div className="popupbox inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="popupin bg-white p-6 rounded-lg shadow-lg max-w-md w-full text-center">
            {!gameOver ? (
              <div>
                                <p className="text-center countryguess">That's in {city.country}</p>

                <p className="text-lg strong mb-2">
                  Your guess is{" "}
                  {Math.round(
                    haversine(guess.lat, guess.lon, correct.lat, correct.lon)
                  ).toLocaleString()}km
                  ({Math.round(
                    haversine(guess.lat, guess.lon, correct.lat, correct.lon) / 1.61
                  ).toLocaleString()} miles) away &nbsp;
                </p>
                <p className="mb-1 score-text">You scored {score} {score === 1 ? "point" : "points"}!</p>
                {/* <p className="blurbtext">{city.blurb}</p> */}
              </div>
            ) : (<div></div>)}

            {gameOver ? (
              <div>
                <h2 className="text-xl font-semibold mb-2 gameovertext">Game Over!</h2>
                <p className="mb-4 totalscore gameovertext">Your total score is: {totalScore}/100</p>
                <p className="gameovertext">SHARE YOUR SCORE</p>
                <section className="combined-share__links text-center">
                  <a className="combined-share__social-link" target="_blank" rel="noopener noreferrer" aria-label="Share on Facebook" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Faljazeera.com%2Fafricaquiz%2F">
                    <svg className="icon icon--facebook icon--social icon--24" viewBox="0 0 20 20" version="1.1" aria-hidden="true"><title>facebook</title><path className="icon-main-color" d="M10,0 C4.47714844,0 0,4.47714844 0,10 C0,14.9912891 3.65685547,19.1283203 8.4375,19.8785157 L8.4375,12.890625 L5.8984375,12.890625 L5.8984375,10 L8.4375,10 L8.4375,7.796875 C8.4375,5.290625 9.93042967,3.90625 12.2146484,3.90625 C13.3087305,3.90625 14.453125,4.1015625 14.453125,4.1015625 L14.453125,6.5625 L13.1921484,6.5625 C11.9499023,6.5625 11.5625,7.33333984 11.5625,8.12416016 L11.5625,10 L14.3359375,10 L13.8925782,12.890625 L11.5625,12.890625 L11.5625,19.8785157 C16.3431445,19.1283203 20,14.9912891 20,10 C20,4.47714844 15.5228516,0 10,0 Z"></path></svg>
                  </a>
                  <a className="combined-share__social-link" target="_blank" rel="noopener noreferrer" aria-label="Share on Twitter" href={tweeturl}>
                    <svg className="icon icon--twitter icon--social icon--24" viewBox="0 0 26 24" version="1.1" aria-hidden="true"><title>twitter</title><path className="icon-main-color" fillRule="evenodd" d="m.063 0 10.039 13.237L0 24h2.273l8.845-9.423L18.263 24H26L15.397 10.018 24.799 0h-2.273l-8.145 8.678L7.801 0H.062Zm3.344 1.652H6.96l15.695 20.696h-3.554L3.407 1.652Z"></path></svg>
                  </a>
                  <a className="combined-share__social-link" target="_blank" rel="noopener noreferrer" aria-label="Share on Whatsapp" href={whatsurl}>
                    <svg className="icon icon--whatsapp icon--social icon--24" viewBox="0 0 20 20" version="1.1" aria-hidden="true"><title>whatsapp</title><path className="icon-main-color" d="M19 9.74a9.54 9.54 0 0 1-9.33 9.74 9 9 0 0 1-4.51-1.21L0 20l1.68-5.23a10 10 0 0 1-1.33-5A9.53 9.53 0 0 1 9.62 0 9.54 9.54 0 0 1 19 9.74zM14.33 12c-.05-.1-.21-.16-.44-.28s-1.35-.7-1.56-.78-.36-.12-.51.12a11.45 11.45 0 0 1-.73.94c-.13.16-.26.18-.49.06a6.28 6.28 0 0 1-1.84-1.19 7 7 0 0 1-1.27-1.66.35.35 0 0 1 .1-.49c.1-.11.23-.28.34-.42a1.6 1.6 0 0 0 .23-.4.42.42 0 0 0 0-.41c-.06-.12-.51-1.3-.7-1.78s-.39-.4-.52-.4H6.5a.83.83 0 0 0-.61.3 2.74 2.74 0 0 0-.8 2A4.63 4.63 0 0 0 6 10.05a9.54 9.54 0 0 0 3.9 3.61c2.33 1 2.33.64 2.75.6a2.33 2.33 0 0 0 1.54-1.14 2 2 0 0 0 .14-1.12z"></path></svg>
                  </a>
                </section>
                <button className="buttonguess px-4 py-2 bg-blue-600 text-white rounded" onClick={restartGame}>
                  PLAY AGAIN
                </button>
              </div>
            ) : (
              <button
                className="buttonguess padit px-4 py-2 bg-green-600 text-white rounded"
                onClick={nextRound}
              >
                Next
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
